import axios from 'axios'
import { TRANSMITIR_EMISSAO_CTE_OS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function transmitirEmissaoCteOs (emisaoCteOsId, empresaId) {

  const url = `${URL}/emissao-cte-os/${emisaoCteOsId}/empresa/${empresaId}/transmitir-cte-os`;
  return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: TRANSMITIR_EMISSAO_CTE_OS,
        payload: response

      })
  );
}
